import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AlterarSenhaComponent } from './pages/alterar-senha/alterar-senha.component';
import { PainelCadastroComponent } from './pages/cadastros/painel/painel-cadastro.component';
import { CarrinhoPaginaComponent } from './pages/carrinho-pagina/carrinho-pagina.component';
import { HomeComponent } from './pages/home/home.component';
import { MeusPedidosComponent } from './pages/meus-pedidos/meus-pedidos.component';
import { LoginComponent } from './pages/login/login.component';
import { MinhaContaComponent } from './pages/minha-conta/minha-conta.component';
import { PerfilClienteComponent } from './pages/cadastros/perfil-cliente/perfil-cliente.component';
import { PerfilUsuarioComponent } from './pages/cadastros/perfil-usuario/perfil-usuario.component';
import { ListaTitulosComponent } from './pages/lista-titulos/lista-titulos.component';
import { ContatosComponent } from './pages/contatos/contatos.component';
import { MuralAvisosComponent } from './pages/mural-avisos/mural-avisos.component';
import { ConsultasGerenciaisComponent } from './pages/cadastros/consultas-gerenciais/consultas-gerenciais.component';
import { ConsultaGerencialComponent } from './pages/consulta-gerencial/consulta-gerencial.component';
import { PixPaginaComponent } from './pages/pix-pagina/pix-pagina.component';
import { LoginGuard } from './guard/login-guard.comoponent';

const routes: Routes = [
	{ path: '', redirectTo: 'login', pathMatch: 'full' },
	{ path: "home", component: HomeComponent, canActivate: [LoginGuard] },   
	{ path: "login", component: LoginComponent },
	{ path: "carrinho", component: CarrinhoPaginaComponent, canActivate: [LoginGuard] },
	{ path: "minha-conta", component: MinhaContaComponent, canActivate: [LoginGuard], children: [
		{ path: "perfil-cliente", component: PerfilClienteComponent},
		{ path: "perfil-usuario", component: PerfilUsuarioComponent},
		{ path: "meus-pedidos", component: MeusPedidosComponent},
		{ path: "alterar-senha", component: AlterarSenhaComponent},
		{ path: "painel-cadastro", component: PainelCadastroComponent},
		{ path: "meus-titulos", component: ListaTitulosComponent},
		{ path: "contatos", component: ContatosComponent},
		{ path: "consulta-gerencial-cadastro", component: ConsultasGerenciaisComponent},
		{ path: "consulta-gerencial", component: ConsultaGerencialComponent}
	]},
	{ path: "mural-avisos", component: MuralAvisosComponent, canActivate: [LoginGuard]},
	{ path: "pagamento-pix", component: PixPaginaComponent}
];

@NgModule({
	imports: [RouterModule.forRoot(routes)],	
    exports: [RouterModule]
})
export class AppRoutingModule { }
